import { ReactElement } from 'react';
import { DataItemFormatter } from '@creditsights/styleguide-web';
import { Tag } from '../../../models';
import CompanyField from '../../CompanyField';

interface CompaniesFormatterProps {
  isBold?: boolean;
}

const CompaniesFormatter: (
  companiesFormatterProps?: CompaniesFormatterProps
) => DataItemFormatter<Tag[], ReactElement, { onItemClick? }> = (companiesFormatterProps) => {
  return ({ value: companies, item, props, configuration, row }) => (
    <CompanyField
      companies={companies}
      item={item}
      stopMouseUpPropagation={configuration?.stopMouseUpPropagation}
      onItemClick={props?.onItemClick}
      isBold={companiesFormatterProps?.isBold}
      row={row}
      configuration={configuration}
    />
  );
};

export default CompaniesFormatter;
